'use client';

import cn from 'classnames';
import PropTypes from 'prop-types';
import { useState } from 'react';
import styles from './email-signup.module.scss';
import pushToDataLayer from 'lib/analytics/pushToDataLayer';
import ChevronR from 'assets/icons/chevron-r.svg';
import { emailSignup } from 'lib/email/emailSignup';

const EmailSignup = (props) => {
	const { header, cta } = props;
	const [email, setEmail] = useState('');
	const [showSuccess, setShowSuccess] = useState(false);
	const [successMessage, setSuccessMessage] = useState('');
	const [showError, setShowError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [isValid, setIsValid] = useState(true);
	const [isEmailDirty, setIsEmailDirty] = useState(false);

	const emailCode = 'web_home';

	const submit = async (e) => {
		e.preventDefault();
		const url = window ? window.location.pathname : undefined;
		//Hide Previous Error State
		if (isValid && email != '') {
			setShowError(false);
			setShowSuccess(false);
			const res = await emailSignup({ email, emailCode, url });
			updatePageAfterSubmit();
			if (res.success) {
				setShowSuccess(true);
				setSuccessMessage(res.message);
			} else {
				setShowError(true);
				setErrorMessage(res.message);
			}
		}
	};

	const checkValidity = (event) => {
		const emailInput = event.target;
		setIsValid(emailInput.validity.valid);
		setIsEmailDirty(true);
	};

	const updatePageAfterSubmit = () => {
		pushToDataLayer({
			Category: 'Email',
			Action: 'Sign up',
			event: 'HomeNewsletterFormSubmitted',
		});
	};

	return (
		<section className={styles['homepage-email']}>
			<form name="footerNewsletter">
				<div className={styles.wrapper}>
					<label className={styles.label} htmlFor="email">
						<h1 className={styles.title}>{header}</h1>
					</label>
					<div className={styles['form-fields']}>
						{!showSuccess ? (
							<div className={styles['input-wrapper']}>
								<input
									className="input"
									type="email"
									autoComplete="email"
									id="email"
									placeholder={cta}
									value={email}
									onChange={(e) => {
										setEmail(e.target.value);
									}}
									onBlur={checkValidity}
									required=""
								/>
								<button
									aria-label="NewsLetter Signup"
									name="Newsletter Signup"
									className={styles.submit}
									type="submit"
									onClick={submit}
								>
									<ChevronR />
								</button>
							</div>
						) : null}
						{!showError && !isValid && isEmailDirty ? (
							<div className={cn(styles.status)}>
								Please enter a valid email address.
							</div>
						) : null}
						{showError ? (
							<div className={cn(styles.status)}>
								<span
									onClick={() => {
										setShowError(false);
									}}
								>
									{errorMessage}
								</span>
							</div>
						) : null}
						{showSuccess ? (
							<div className={cn(styles.status)}>
								<span
									onClick={() => {
										setShowSuccess(false);
									}}
								>
									{successMessage}
								</span>
							</div>
						) : null}
					</div>
				</div>
			</form>
		</section>
	);
};

EmailSignup.propTypes = {
	cta: PropTypes.any,
	header: PropTypes.any,
};

export default EmailSignup;
